module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-header', [_c('small', [_vm._v("End of battle")])]), _vm._v(" "), _c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', [(_vm.values.playerWins) ? _c('i', {
    staticClass: "fa fa-trophy",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.values.playerWins) ? _c('i', {
    staticClass: "fa fa-frown-o",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n\t\t\t" + _vm._s(_vm.message) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "pull-left",
    attrs: {
      "src": _vm.apiUrl + _vm.winner.avatar,
      "alt": _vm.winner.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 padding-top"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.winner.name))]), _vm._v(" is the winner!!! "), _c('b', [_vm._v(_vm._s(_vm.loser))]), _vm._v(" had no chances and was destroyed!")]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "to": {
        name: 'selection'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Try again\n\t\t\t\t\t")])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0523fde2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/end/index.vue
// module id = 120
// module chunks = 1